export default __webpack_public_path__ + "static/media/icon-upload.22e7e5c9.svg";